<div class="row m-2">
    <ng-template [ngTemplateOutlet]="datepicker" [ngTemplateOutletContext]="{disabled: false}">
    </ng-template>
    <ng-template [ngTemplateOutlet]="datepicker" [ngTemplateOutletContext]="{disabled: true}">
    </ng-template>
</div>
<div class="row m-2">
    <ng-template [ngTemplateOutlet]="datetimepicker" [ngTemplateOutletContext]="{disabled: false}">
    </ng-template>
    <ng-template [ngTemplateOutlet]="datetimepicker" [ngTemplateOutletContext]="{disabled: true}">
    </ng-template>
</div>

<!--Date Picker-->
<ng-template #datepicker let-disabled='disabled'>
    <div class="col-4">
        <label class="k-form-field test-label-width">
            <span class="k-text-uppercase dark">
                <span *ngIf="disabled">Disabled&nbsp;</span>Date Picker
            </span>
            <kendo-datepicker [min]="minDOB" [max]="maxDOB" [disabled]="disabled">
            </kendo-datepicker>
        </label>
    </div>
</ng-template>

<!--DateTime Picker-->
<ng-template #datetimepicker let-disabled='disabled'>
    <div class="col-4">
        <label class="k-form-field test-label-width">
            <span class="k-text-uppercase dark">
                <span *ngIf="disabled">Disabled&nbsp;</span>Date Time Picker
            </span>
            <kendo-datetimepicker [disabled]="disabled"></kendo-datetimepicker>
        </label>
    </div>
</ng-template>